// UserByUsername.jsx
'use strict';
import React from 'react';
import PropTypes from 'prop-types';
import Redirect from '../container/Redirect.js';
import { LIVESTREAM_PATH } from '../resource/liveStreamConstants.js';
import { getIsIphoneXSeriesPWA } from '../resource/getUserAgent.js';
import {
  footerNavigationHeight,
  iPhoneXSeriesFooterPaddingInPWA,
} from '../style/variables.js';

import UniversalComponent from '../component/UniversalComponent.jsx';

class UserByUsername extends React.PureComponent {
  constructor(props) {
    super(props);

    const { username, userId, fetchUserByUsername, staticContext, fetchError } =
      props;

    // server side fetching
    if (staticContext.actions) {
      if (fetchError) {
        staticContext.error = fetchError;
      }
      if (username && !userId) {
        staticContext.actions.push({
          function: fetchUserByUsername,
          argumentObject: {
            username,
            httpProxyHeaders: staticContext.httpProxyHeaders,
          },
        });
      }
    }
  }

  componentDidMount() {
    const { userId, username, fetchUserByUsername } = this.props;
    if (!userId && username) {
      fetchUserByUsername({ username });
    }
  }

  componentDidUpdate(prevProps) {
    const { isAuthed, fetchUserByUsername, username, userId } = this.props;
    if (isAuthed !== prevProps.isAuthed && !userId && username) {
      fetchUserByUsername({ username });
    }
  }
  render() {
    const { userId, isFetching, listType, publishStatus } = this.props;

    if (userId) {
      if (listType === LIVESTREAM_PATH) {
        return (
          <UniversalComponent
            filename="Container_LiveStreams"
            userId={userId}
            streamId={userId}
            footerNavigationHeight={
              getIsIphoneXSeriesPWA()
                ? footerNavigationHeight + iPhoneXSeriesFooterPaddingInPWA
                : footerNavigationHeight
            }
            importer={
              /* #__LOADABLE__ */ () => import('../container/LiveStreams.js')
            }
          />
        );
      }
      return (
        <UniversalComponent
          filename="Container_UserByUserId"
          userId={userId}
          listType={listType}
          publishStatus={publishStatus}
          importer={
            /* #__LOADABLE__ */ () => import('../container/UserByUserId.js')
          }
        />
      );
    } else if (isFetching) {
      return <div>Loading...</div>;
    } else {
      return <Redirect to="/404" />;
    }
  }
}

UserByUsername.propTypes = {
  staticContext: PropTypes.object,
  userId: PropTypes.string,
  username: PropTypes.string,
  listType: PropTypes.string,
  publishStatus: PropTypes.string,
  isFetching: PropTypes.bool,
  fetchError: PropTypes.instanceOf(Error),
  isAuthed: PropTypes.bool,
  fetchUserByUsername: PropTypes.func,
};

UserByUsername.defaultProps = {
  staticContext: {},
  userId: '',
  username: '',
  listType: null,
  publishStatus: null,
  isFetching: true,
  fetchError: null,
  isAuthed: false,
  fetchUserByUsername: () => null,
};

export default UserByUsername;
